import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/WestminsterTower/TheResidencesBanner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/WestminsterTower/TheResidencesDesigning/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/WestminsterTower/TheResidencesIntroduction/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/WestminsterTower/TheResidencesPortfolio/index.tsx");
